$(function() {
  const gHeader = $('#js-global-header').height()
  const ww = $(window).width()

  function pagelink(heightnum) {
    const headerH = heightnum
    $('a[href^="#"]').click(function() {
      const href = $(this).attr('href')
      const target = $(href == '#' || href == '' ? 'body' : href)
      const notPcPosition = target.offset().top - headerH
      const pcPosition = target.offset().top

      if (ww <= 1200) {
        $('html, body').animate({ scrollTop: notPcPosition }, 800, 'swing')
      } else {
        $('html, body').animate({ scrollTop: pcPosition }, 800, 'swing')
      }
      return false
    })
  }
  pagelink(gHeader)
})
